import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyA5_UnLwAA5VilwxU5MYCDpR_UJYojUhW4",
  authDomain: "reuseit-1c2b6.firebaseapp.com",
  projectId: "reuseit-1c2b6",
  storageBucket: "reuseit-1c2b6.firebasestorage.app",
  messagingSenderId: "224431030902",
  appId: "1:224431030902:web:a59432153117692975d557",
  measurementId: "G-93SW31T7JY"
};

const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, 'europe-west1');

export default app;
